<template>
  <div class="lillan-show__gallery show--gallery">
    <div class="lillan-show__gallery-title">
      <h2 id="gallery">{{ context.translations.gallery }}</h2>
    </div>
    <div v-masonry="'containerId'"
        transition-duration="0"
        item-selector=".masonry-item"
        column-width=".masonry-item"
        class="masonry-container"
    >
      <div v-for="(image, index) in filteredImages" class="masonry-item">
        <div class="masonry-item__inner">
          <div class="responsive-image-container"
              v-bind:style="`padding-bottom: ${image.height / image.width * 100}%;`">
            <img :key="index" class="responsive-image img-fluid image"
                v-bind:src="image.image"
                alt=""
                @click="showImg(index)"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="lillan-show__gallery-button-container">
      <button class="lillan-button-small" v-if="!showAll" v-on:click="showAllImages">{{ context.translations.show_all }}</button>
    </div>
    <vue-easy-lightbox
        moveDisabled
        rotateDisabled
        zoomDisabled
        :visible="visible"
        :imgs="imgs"
        :index="index"
        @hide="handleHide"
    >
      <template v-slot:toolbar="{ toolbarMethods }">
        <button class="invisible" @click="toolbarMethods.zoomIn"></button>
      </template>
    </vue-easy-lightbox>
  </div>
</template>

<script>

import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  //props: [ 'context' ],
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  components: {
    VueEasyLightbox,
  },
  data: function() {
    return {
      showAll: this.context.images.length < 5,
      imgs: this.context.images.map((item) => {
        let caption = item.caption || ''; // Use an empty string if caption is undefined
        return {
          src: item.image,
          title: caption.length > 0 ? caption : '',
        };
      }),
      visible: false,
      index: 0,
    };
  },
  methods: {
    showAllImages() {
      this.showAll = true;
      setTimeout(() => {
        this.$redrawVueMasonry('containerId');
      }, 1);
    },
    showImg(index) {
      this.index = index;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
  },
  computed: {
    filteredImages() {
      if (!this.showAll) {
        return this.context.images.slice(0, 4);
      }
      return this.context.images;
    },
  },
};

</script>
